import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewFiltersModel } from '../../../allocation-view/models';
import { AllocationViewFilterProfileModel } from '../../models';
import { AllocationViewProfilesEndpoint } from './../../constants';
@Injectable({
  providedIn: 'root',
})
export class AllocationViewFilterProfileItemService {
  private readonly filterProfileKey = 'allocation-view-filter-profile';
  private readonly profileFilterUrl = `${API_URL}${AllocationViewProfilesEndpoint.DockAndYard}${AllocationViewProfilesEndpoint.Monitoring}${AllocationViewProfilesEndpoint.Filters}${AllocationViewProfilesEndpoint.Profiles}`;

  constructor(private http: WrapperHttpService) {}

  setFilterProfile(item: AllocationViewFilterProfileModel): void {
    localStorage.setItem(this.filterProfileKey, JSON.stringify(item));
  }

  getSelectedFilterProfile(): AllocationViewFilterProfileModel {
    const filterProfileJson = localStorage.getItem(this.filterProfileKey);
    return JSON.parse(filterProfileJson) || null;
  }

  createFilterProfile(name: string, filters: AllocationViewFiltersModel): Observable<AllocationViewFilterProfileModel> {
    return this.http.withLoading().post(this.profileFilterUrl, { name, filters });
  }

  updateFilterProfile(item: AllocationViewFilterProfileModel): Observable<AllocationViewFilterProfileModel> {
    return this.http.withLoading().put(this.profileFilterUrl, item);
  }

  deleteFilterProfile(id: number): Observable<void> {
    return this.http.withLoading().delete<void>(`${this.profileFilterUrl}/${id}`);
  }
}
